/**
 * Seasonal menu links (RET-293).
 *
 * A menu link to a collection with custom.menu_show_from and
 * custom.menu_show_until (MM-DD) shows only inside that window, every year.
 * snippets/kc-season-attrs.liquid marks those list items with
 * data-kc-season="MM-DD MM-DD" and a first guess at `hidden`, but Liquid's
 * 'now' is the time the page was last rendered and Shopify caches renders.
 * This script makes the real decision with the visitor's own date.
 *
 * Header hydration (section-hydration.js) re-renders the menu after load and
 * can put the server's guess back, so a MutationObserver re-applies. It only
 * writes `hidden` when the value differs, which is what stops it looping.
 *
 * QA: on an unpublished theme, ?kc_season_date=MM-DD stands in for today, so
 * a preview can be checked on any date. The live theme ignores it.
 */
(function () {
  var override = null;
  var theme = window.Shopify && window.Shopify.theme;
  if (theme && theme.role !== 'main') {
    var param = new URLSearchParams(window.location.search).get('kc_season_date');
    if (param && /^\d{2}-\d{2}$/.test(param)) override = Number(param.replace('-', ''));
  }

  function today() {
    if (override) return override;
    var now = new Date();
    return (now.getMonth() + 1) * 100 + now.getDate();
  }

  function inSeason(from, until, day) {
    if (from <= until) return day >= from && day <= until;
    return day >= from || day <= until;
  }

  function apply() {
    var day = today();
    var items = document.querySelectorAll('[data-kc-season]');
    for (var i = 0; i < items.length; i++) {
      var range = items[i].getAttribute('data-kc-season').split(' ');
      var from = Number(range[0].replace('-', ''));
      var until = Number(range[1].replace('-', ''));
      var hide = !inSeason(from, until, day);
      if (items[i].hidden !== hide) items[i].hidden = hide;
    }
  }

  apply();
  new MutationObserver(apply).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });
})();
